export const sortByPublishAt = (items = [], order = "desc") => {
  if (!Array.isArray(items)) {
    return [];
  }

  return [...items].sort((a, b) => {
    const dateA = new Date(a.published_at).getTime();
    const dateB = new Date(b.published_at).getTime();

    return order === "asc" ? dateA - dateB : dateB - dateA;
  });
};
